export default "__VITE_ASSET__cd1f515c__"